/**
 * HTML Pages Indexes
 */
export const PAGE_HOTELS_LIST = 2
export const PAGE_HOTEL = 10
export const PAGE_BF_FIRST_STEP = 11

export const EMPTY_IMAGE_BASE64 =
  'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';

export const ADAGIO_ORIGINAL_LABEL = 'Adagio Original';

export const ADAGIO_ACCESS_LABEL = 'Adagio Access';

export const ADAGIO_PREMIUM_LABEL = 'Adagio Premium';

export const FORM_SECOND_STEP = 'secondStep'
